import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFC]">
        <div className="w-10 h-10 rounded-full border-4 border-brand-purple/20 border-t-brand-purple animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  const staff = ["admin", "manager", "producer", "editor"];
  if (roles === "staff" && !staff.includes(user.role)) return <Navigate to="/client" replace />;
  if (roles === "client" && user.role !== "client") return <Navigate to="/admin" replace />;
  return children;
}
